import * as React from "react";
import {observer} from "mobx-react";
import {StyleRulesCallback, WithStyles, withStyles} from "@material-ui/core/styles";
import FormStepper from "../../components/FormStepper/FormStepper";
import {InputTypes} from "../../components/FormStepper/InputTypes";
import {RouteComponentProps} from "react-router";
import FormButton from "../../../../components/FormButton/FormButton";
import FormFinish from "../SignUpForm/FormFinish/FormFinish";
import Loader from "../../../../components/Loader/Loader";

interface IProps extends RouteComponentProps<any> {
    closeWindowNavigationPath : string;
    store: any;
    isSending: boolean
}

interface ILocalState {
    isFormFinish: boolean;
    renderFinishPage: boolean;
}

const storePropertyName = 'manageLoanPlan';

const FORM_MANAGE_LOAN_PLAN_TEXTS = {
    titles: {
        HEADER: "Manage your loan",
        CALENDER_TITLE: "Select the loan adjustments start date",
        REASON_TITLE: "What would you like to do?",
        BUTTON_TEXT: "Submit a request"
    },
    placeHolders: {
        DROPDOWN_PLACEHOLDER: "Choose your answer"
    },
    propertyNames: {
        START_DATE: "startDate",
        SELECTED_ACTION: "selectedAction"
    }
};


const styles: StyleRulesCallback = ({ palette, spacing }) => ({
    buttonContainer: {
        width: "86%",
        marginLeft: "2.5em",
        marginBottom: "1em"
    },
    error: {
        fontSize: 13,
        color: "#E96767",
        marginTop: "1em",
        textAlign: "center"
    }
});

@observer
@(withStyles(styles) as any)
export default class FormManageLoanPlan  extends React.Component<
    IProps & Partial<WithStyles<any>>
    > {

    public state: ILocalState = {
        isFormFinish: false,
        renderFinishPage: false,
    };

    public renderFormStepper = () => {
        const {store} = this.props;
        store.reset();
        return <FormStepper steps={this.getManageLoanSteps()} updateParentFormStatus={this.getFormStatus}  store={store} navigationProperty={storePropertyName}/>
    };

    public render() {
        const {store} = this.props;
        return store.isSending? <Loader/> : this.state.renderFinishPage ?
            <FormFinish store={store} isUpgrade={true} {...this.props} />:
            <>
                {this.renderFormStepper()}
                {this.renderSubmitButton()}
            </> ;

    }

    private getManageLoanSteps = () => {
        const manageLoanSteps: any =  [
            {
                isHeader: true,
                title: FORM_MANAGE_LOAN_PLAN_TEXTS.titles.HEADER,
                inputType: InputTypes.none
            },
            {
                title: FORM_MANAGE_LOAN_PLAN_TEXTS.titles.REASON_TITLE,
                inputPlaceHolder: FORM_MANAGE_LOAN_PLAN_TEXTS.placeHolders.DROPDOWN_PLACEHOLDER,
                inputType: InputTypes.dropdown,
                options: this.getLoanActions(),
                cb: this.updateSelectedLoanAction,
                propName: FORM_MANAGE_LOAN_PLAN_TEXTS.propertyNames.SELECTED_ACTION
            }
        ];
        return manageLoanSteps;
    };

    private renderSubmitButton = () => {
        const {classes} = this.props;
        const buttonClass = this.state.isFormFinish? "blue" : "disabled";
        return (<div className={classes!.buttonContainer}>
            <FormButton btnText={FORM_MANAGE_LOAN_PLAN_TEXTS.titles.BUTTON_TEXT} click={this.submitLoanChangesRequest} classes={buttonClass}/>
            {this.renderErrorIfNeeded()}
        </div>)
    }

    private submitLoanChangesRequest = async () => {
        const {store} = this.props;
        if(!this.state.isFormFinish) {
            return;
        }
        const newState = this.state;
        const loanRequestResults = await store.submitLoanChangesRequest();
        newState.renderFinishPage = loanRequestResults && loanRequestResults.ok;
        this.setState(newState);
    }

    private getFormStatus = (isFormFinished: boolean) => {
        if(this.state.isFormFinish !== isFormFinished) {
            const newState = this.state;
            newState.isFormFinish = isFormFinished;
            this.setState(newState)
        }
    }

    private getLoanActions = () => {
        return [
            {label: "Defer the next payment in one month", value: "defer payment"},
            {label: "Repay the loan balance in full", value: "full repayment"},
            {label: "Repay a partial amount", value: "Other"}
        ]
    };

    private updateSelectedLoanAction = (value: string) => {
        const {store} = this.props;
        store.formInput[storePropertyName][FORM_MANAGE_LOAN_PLAN_TEXTS.propertyNames.SELECTED_ACTION] = value;
    }

    private renderErrorIfNeeded = () => {
        const {classes, store} = this.props;
        return store.error?<div className={classes!.error}>There was an error processing your loan defer request, please connect our <a href="mailto:support@salaryo.com">
            customer support
        </a> or try again later </div> : null
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormManageLoanPlan/FormManageLoanPlan.tsx